import dayjs from "dayjs";

import { useEffectOnce } from "react-use";
import { useFormContext } from "react-hook-form";
import { useForm } from "@/shared/libs/react-hook-form";
import {notificationApi, NotificationItem, notificationSchema} from "./index";



const defaultFormValue: NotificationItem = {
  id: "",
  companyCode: "",
  createBy: "",
  createName: "",
  createTime: "",
  orderNum: 0,
  recordStatus: 1,
  notificationSn:"",
  notificationType:"",
  title:"",
  content:"",
  businessType:"",
  businessId:"",
  senderId:"",
  senderName:"",
  expireTime:"",
  receiverIds:[],
  priority:""
};

export const useNotificationForm = (
  defaultValue?: NotificationItem,
  defaultId?: string
) => {
  const methods = useForm({
    schema: notificationSchema,
    defaultValues: {
      ...defaultFormValue,
      ...defaultValue,
    },
  });
  useEffectOnce(() => {
    if (!defaultId) return;
    notificationApi.find(defaultId).then((result) => {
      const newValue: NotificationItem = {
        recordStatus: 1,
        businessId: result.businessId,
        businessType: result.businessType,
        companyCode: result.companyCode,
        content: result.content,
        createBy: result.createBy,
        createName: result.createName,
        createTime: result.createTime,
        expireTime: result.expireTime,
        notificationSn: result.notificationSn,
        notificationType: result.notificationType,
        orderNum: 0,
        receiverIds: result.receiverIds, //接收人ID
        senderId: result.senderId,
        senderName: result.senderName,
        title: result.title,
        priority:result.priority,
        id: result.id
      };
      methods.reset(newValue);
    });
  });

  return methods;
};

export const handleSubmit = (value: NotificationItem) => {
  return {
    ...value,
    // ledgerDetailsList: value.ledgerDetailsList.map((item) => ({
    //   ...item,
    //   resultFlag: item.resultFlag ? "Y" : "N",
    //   selectFlag: item.selectFlag ? "Y" : "N",
    // })),
    // detectionDate: value.detectionDate
    //   .map((date) => {
    //     if (!date) return "";
    //     return dayjs(date).format("YYYY-MM-DD");
    //   })
    //   .join(","),
  };
};

export const useNotificationItemContext = useFormContext<NotificationItem>;

export const useNotificationEffect = (
  methods: ReturnType<typeof useNotificationForm>
) => {
  useEffectOnce(() => {
    const subscription = methods.watch((_val, { name }) => {});
    return () => subscription.unsubscribe();
  });
};
